module.exports = __webpack_public_path__ + "media/img/covers/profile-cover-2-small-89d8020ac8729fb33fd86cb0286099d5.jpg";